<ion-content class="ion-no-padding">
  <div class="lead-form itinerary-model-container">
    <div class="itinerary-model-header">
      <ion-header class="ion-no-border ion-padding-horizontal sticky-top bg-white">
        <ion-toolbar class="header-first-toolbar">
          <ion-title class="text-start ion-no-padding title-blue">Organization On-Boarding Process <span *ngIf="editOrganizationId">({{editOrganizationId}})</span></ion-title>
          
          <ion-buttons slot="end" class="ion-no-margin">
            <ion-button (click)="closeModal()" class="header-button-cancel unfilled-gray-btn">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
  
      <div class="dashed-line"></div>
  
      <div class="d-flex py-1 flex-wrap ion-padding-horizontal nav-buttons-container">
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'details', 'tab-green': organizationDetailsFormData?.dataSaved, 'tab-red': organizationDetailsFormData?.dataInvalid }"  (click)="onViewChangeFromTab('details')">Details</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'brand', 'tab-green': brandDetailsFormData?.dataSaved, 'tab-red': brandDetailsFormData?.dataInvalid }"  (click)="onViewChangeFromTab('brand')" [disabled]="!organizationId">Brand Details</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'subscriptions', 'tab-green': packageFormData?.dataSaved, 'tab-red': packageFormData?.dataInvalid }"  (click)="onViewChangeFromTab('subscriptions')" [disabled]="!organizationId">Packages</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'access', 'tab-green': accessModulesFormData?.dataSaved, 'tab-red': accessModulesFormData?.dataInvalid }"  (click)="onViewChangeFromTab('access')" [disabled]="!organizationId">Access Modules</ion-button>
      </div>
    </div>
    

    <div [ngSwitch]="componentView" class="itinerary-model-content-main">

      <!-- Organization and users -->
      <app-user-org-details  *ngSwitchCase="'details'" [organizationId]="organizationId"
      [editOrganizationId]="editOrganizationId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeOrgDetailsData($event)"
      [storedFormData]="organizationDetailsFormData"
      (assignOrganizationId)="assignOrganizationId($event)"
      (submitOrganizationData)="onSubmit()"
      [isUserEditing]="isUserEditing"
      ></app-user-org-details>

      <!-- Organization branch details -->
      <app-brand-details  *ngSwitchCase="'brand'" [organizationId]="organizationId"
      [editOrganizationId]="editOrganizationId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeBrandDetailsData($event)"
      [storedFormData]="brandDetailsFormData"
      (submitOrganizationData)="onSubmit()"
      [isUserEditing]="isUserEditing"
      ></app-brand-details>

      <!-- Subscroption selection comp -->
      <app-subscription-selection  *ngSwitchCase="'subscriptions'" [organizationId]="organizationId"
      [editOrganizationId]="editOrganizationId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storePackageData($event)"
      [storedFormData]="packageFormData"
      (submitOrganizationData)="onSubmit()"
      [isUserEditing]="isUserEditing"
      ></app-subscription-selection>

      <!-- Access modules -->
      <app-modules-access  *ngSwitchCase="'access'" [organizationId]="organizationId"
      [editOrganizationId]="editOrganizationId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeAccessModulesData($event)"
      [storedFormData]="accessModulesFormData"
      (submitOrganizationData)="onSubmit()"
      (showReview)="showReview($event)"
      [isUserEditing]="isUserEditing"
      ></app-modules-access>

    </div>
  </div>
</ion-content>
